__turbopack_context__.v({
  "background": "RecoveryHeroSection-module__x6lEuq__background",
  "copyBlock": "RecoveryHeroSection-module__x6lEuq__copyBlock",
  "heroMediaArea": "RecoveryHeroSection-module__x6lEuq__heroMediaArea",
  "heroPoster": "RecoveryHeroSection-module__x6lEuq__heroPoster",
  "heroSignalBand": "RecoveryHeroSection-module__x6lEuq__heroSignalBand",
  "heroVideo": "RecoveryHeroSection-module__x6lEuq__heroVideo",
  "location": "RecoveryHeroSection-module__x6lEuq__location",
  "mediaFrame": "RecoveryHeroSection-module__x6lEuq__mediaFrame",
  "overlay": "RecoveryHeroSection-module__x6lEuq__overlay",
  "section": "RecoveryHeroSection-module__x6lEuq__section",
  "subtitle": "RecoveryHeroSection-module__x6lEuq__subtitle",
  "title": "RecoveryHeroSection-module__x6lEuq__title",
  "titleWrap": "RecoveryHeroSection-module__x6lEuq__titleWrap",
});
